import { useDispatch } from 'react-redux';
import { authActions, kioskLoginActions } from '../_store';
import { useNavigate } from 'react-router-dom';
import { getStoredValue, setStoredValue , removeStoredValue } from "../_helpers/storageHelper";

const useKioskRestrictIntervalValidation = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const storedloginResponse = getStoredValue("loginResponse");
    const PodSharedStatus = getStoredValue('PodSharedStatus') 

    const validateKioskRestrictInterval = async (storedLoginDetails, btnfunction) => {
        if (storedLoginDetails?.FacilityID && storedLoginDetails?.KiosksCode) {
            const response = await dispatch(
                kioskLoginActions.getKioskRestrictIntervalValidate({
                    facilityID: storedLoginDetails.FacilityID,
                    kioskCode: storedLoginDetails.KiosksCode,
                    InmateResidentId : storedloginResponse?.InmatesResdId || ''
                })
            );
            const Result = response?.payload;
            if (Result?.length > 0) {
                setStoredValue('KioskRestrictIntervalValidate', Result[0]);
                if (storedloginResponse?.InmatesResdId) {
                    setStoredValue('PodSharedStatus', Result[0]?.PodSharedStatus);
                    if (PodSharedStatus == 1 && Result[0]?.PodSharedStatus == 0) {
                        dispatch(authActions.logout());  
                    }
                }
                if (Result[0]?.IsKioskRestrictIntervalLock == 1 || Result[0]?.KiosksLockDownStatus == 1 || Result[0]?.InmateLockDownStatus == 1 ||
                    Result[0]?.KiosksActiveStatus == 0 || Result[0]?.PodActiveStatus == 0) {
                    navigate((btnfunction == "Login" && Result[0]?.KiosksActiveStatus == 0 && Result[0]?.PodActiveStatus == 1) ? '/KioskSetup' : '/');
                    if (Result[0]?.KiosksActiveStatus == 0 && btnfunction == "Login" && Result[0]?.PodActiveStatus == 1) {
                        localStorage.clear(); removeStoredValue('KIOKEY'); window.location.reload();
                    }
                    //navigate('/');
                    return false;
                }
                return true;
            }
        }
    };

    return validateKioskRestrictInterval;
};

export default useKioskRestrictIntervalValidation;
